import React, { Fragment } from 'react';

import clsx from 'clsx';

import PerfectScrollbar from 'react-perfect-scrollbar';

import {Box, Hidden, Drawer, Button, Paper} from '@material-ui/core';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';



import { connect } from 'react-redux';

import SidebarHeader from '../../layout-components/SidebarHeader';
import SidebarMenu from '../../layout-components/SidebarMenu';
import SidebarFooter from '../../layout-components/SidebarFooter';

import navItems from './navItems';

import {
  setSidebarToggleMobile,
  setSidebarHover,
  setSidebarToggle,
  setSidebarFooter,
  
} from '../../reducers/ThemeOptions';

const Sidebar = props => {
  const {
    setSidebarToggleMobile,
    sidebarToggleMobile,
    sidebarFixed,

    sidebarHover,
    setSidebarHover,
    sidebarToggle,

    sidebarShadow,
    sidebarFooter
  } = props;

  const toggleHoverOn = () => setSidebarHover(true);
  const toggleHoverOff = () => setSidebarHover(false);

  const closeDrawer = () => setSidebarToggleMobile(!sidebarToggleMobile);
  const alumno = JSON.parse(sessionStorage.getItem("alumno"));
  const carreras = JSON.parse(sessionStorage.getItem("carreras"));
  const datos = { nombre: alumno.nombres, apellido: alumno.apellido, dni:alumno.documento,email: alumno.email, carrera:carreras};

  const sidebarMenuContent = (
    <div
      className={clsx({
        'app-sidebar-nav-close': sidebarToggle && !sidebarHover
      })}>
      {navItems.map(list => (
        <SidebarMenu
          component="div"
          key={list.label}
          pages={list.content}
          title={list.label}
        />
      ))}
      <div className="card-header--actions d-flex justify-content-center mt-3">
        {carreras.length > 0 ? 
          <form action="https://plataforma2.iunir.edu.ar/login/LoginCs" method="post" target='_blank'>
            <input type='hidden' name='nombre' id='nombre' value={datos.nombre} />
            <input type='hidden' name='apellido' id='apellido' value={datos.apellido} />
            <input type='hidden' name='dni' id='dni' value={datos.dni} />
            <input type='hidden' name='email' id='email' value={datos.email} />
            <input type='hidden' name='legajo' id='legajo' value={carreras[0].legajo} />
            <input type='hidden' name='carrera' id='carrera' value={carreras[0].carrera} />
            <input type='hidden' name='anio' id='anio' value={carreras[0].anio!=null?carreras[0].anio:1} />
              <Box  style={{ display: 'flex', justifyContent: 'flex-end' }}>                
                  <Button type="submit" size="medium" variant="outlined" color="primary" className="mb-3 mr-3">
                    <AttachMoneyIcon/>
                    Pagar Cuota
                  </Button>
              </Box>
          </form>    
          : console.log("No hay registro de inscripciones a carreras")}
      </div>
    </div>
  );

  return (
    <Fragment>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          open={sidebarToggleMobile}
          onClose={closeDrawer}
          variant="temporary"
          elevation={4}
          className="app-sidebar-wrapper-lg">
          <SidebarHeader />
          <PerfectScrollbar>
            {sidebarMenuContent}
            {sidebarFooter && <SidebarFooter />}
          </PerfectScrollbar>
        </Drawer>
      </Hidden>

      <Hidden mdDown>
        <Paper
          onMouseEnter={toggleHoverOn}
          onMouseLeave={toggleHoverOff}
          className={clsx('app-sidebar-wrapper', {
            'app-sidebar-wrapper-close': sidebarToggle,
            'app-sidebar-wrapper-open': sidebarHover,
            'app-sidebar-wrapper-fixed': sidebarFixed
          })}
          square
          open={sidebarToggle}
          elevation={sidebarShadow ? 11 : 3}>
          <SidebarHeader />
          <div
            className={clsx({
              'app-sidebar-menu': sidebarFixed,
              'app-sidebar-collapsed': sidebarToggle && !sidebarHover
            })}>  
            <PerfectScrollbar options={{ wheelPropagation: false }}>           
              {sidebarMenuContent}
              {sidebarFooter && <SidebarFooter />}
            </PerfectScrollbar>          
          </div>
        </Paper>
      </Hidden>
    </Fragment>
  );
};

const mapStateToProps = state => ({
  sidebarFixed: state.ThemeOptions.sidebarFixed,
  headerFixed: state.ThemeOptions.headerFixed,
  sidebarToggle: state.ThemeOptions.sidebarToggle,
  sidebarHover: state.ThemeOptions.sidebarHover,
  sidebarShadow: state.ThemeOptions.sidebarShadow,
  sidebarFooter: state.ThemeOptions.sidebarFooter,  
  sidebarToggleMobile: state.ThemeOptions.sidebarToggleMobile
});

const mapDispatchToProps = dispatch => ({
  setSidebarToggleMobile: enable => dispatch(setSidebarToggleMobile(enable)),
  setSidebarToggle: enable => dispatch(setSidebarToggle(enable)),
  setSidebarHover: enable => dispatch(setSidebarHover(enable)),
  setSidebarFooter: enable => dispatch(setSidebarFooter(enable)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
